function n(o){return typeof o=="symbol"||o instanceof Symbol}export{n as isSymbol};
